import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "@/react/components/shared/BuilderUI/Hooks/useTopBlockStyles";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { primaryBlockDefaultStyles } from "../../constants";

export interface HomepageBlock1Props extends ComponentPropsWithRef<"div"> {
  buttons?: ReactNode;
  leftContent?: ReactNode;
  rightContent?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HomepageBlock1 = forwardRef<HTMLDivElement, HomepageBlock1Props>(
  ({ leftContent, buttons, styles, rightContent, className, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: primaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background style={backgroundStyles}>
          <BlockSection.Content
            style={{
              ...paddingStyles,
              ...marginStyles,
            }}
          >
            <div className="wb-flex wb-flex-col md:wb-grid md:wb-grid-cols-2">
              <div className="wb-flex wb-flex-col wb-gap-3 md:wb-gap-5 wb-text-center md:wb-text-left wb-p-6 md:wb-px-16 md:wb-py-28 place-content-center">
                {leftContent}
                <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-flex-wrap wb-gap-3 md:wb-flex-row md:wb-gap-3 wb-mt-2">
                  {buttons}
                </BlockSection.NestedBlock>
              </div>
              <BlockSection.NestedBlock className="wb-mx-auto wb-flex wb-flex-col wb-gap-4 wb-w-full">
                {rightContent}
              </BlockSection.NestedBlock>
            </div>
          </BlockSection.Content>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

HomepageBlock1.displayName = "HomepageBlock1";
